import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { DRAWER } from '../../../tokens';

// Shared loading / empty states so every selected-process panel looks identical.
const centeredColumn = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 1,
  py: 4,
};

export function DrawerLoading({ label = 'Loading data...', subtext }) {
  return (
    <Box sx={centeredColumn}>
      <CircularProgress size={34} thickness={4} sx={{ color: DRAWER.accent }} />
      <Typography
        sx={{
          color: DRAWER.text,
          fontSize: 14,
          fontWeight: 500,
          letterSpacing: 0.3,
        }}
      >
        {label}
      </Typography>
      {subtext ? (
        <Typography sx={{ color: DRAWER.textMuted, fontSize: 12 }}>
          {subtext}
        </Typography>
      ) : null}
    </Box>
  );
}

export function DrawerEmpty({ children }) {
  return (
    <Box sx={centeredColumn}>
      <Typography
        sx={{
          color: DRAWER.textMuted,
          fontSize: 16,
          textAlign: 'center',
          px: 3,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}
